/* eslint-disable no-console */
import Vue from 'vue'
import axios from 'axios'
import configuration from '@/config'
import { getUserToken } from '@/utils/localStorage'

const axiosInstance = axios.create({
  baseURL: configuration.BASE_URL_API
})

axiosInstance.interceptors.request.use((config) => {
  if (!config.headers.common.Authorization) {
    // eslint-disable-next-line no-param-reassign
    config.headers.common.Authorization = `Bearer ${getUserToken()}`
  }

  return config
}, (error) => Promise.reject(error))

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if ([401, 403].includes(error.response?.status)) {
      if (Vue.prototype.$liff.isInClient()) {
        Vue.prototype.$liff.closeWindow()
      } else {
        Vue.prototype.$auth.logout()
      }
    } else {
      Vue.prototype.$swal({
        title: 'มีบางอย่างผิดพลาด',
        text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
        icon: 'error'
      })
    }

    return Promise.reject(error)
  }
)

class HttpRequest {
  constructor () {
    this.axiosInstance = axiosInstance
  }

  setHeader (header) {
    this.axiosInstance.defaults.headers.common[header.key] = header.value
  }

  fetch (methodName, data) {
    return this.axiosInstance.get(methodName, { params: data })
  }

  create (methodName, data) {
    return this.axiosInstance.post(methodName, data)
  }

  update (methodName, data, params) {
    return this.axiosInstance.put(methodName, data, { params })
  }

  edit (methodName, data) {
    return this.axiosInstance.patch(methodName, data)
  }

  remove (methodName, data) {
    return this.axiosInstance.delete(methodName, { data })
  }

  delete (methodName, id) {
    return this.axiosInstance.delete(methodName, { params: { id } })
  }

  static request (type, url, data) {
    let promise = null
    switch (type) {
      case 'GET': promise = axios.get(url, { params: data })
        break
      case 'POST': promise = axios.post(url, data)
        break
      case 'PUT': promise = axios.put(url, data, { params: data })
        break
      case 'PATCH': promise = axios.patch(url, data)
        break
      case 'DELETE': promise = axios.delete(url, data)
        break
      default: promise = axios.get(url, { params: data })
    }
    return promise
  }
}

export default HttpRequest
